export const GET_GIT_REPOS = "GET_GIT_REPOS";
export const GET_GIT_REPO_BY_ID = "GET_GIT_REPO_BY_ID";
export const UPDATE_GIT_REPO = "UPDATE_GIT_REPO";
export const DELETE_GIT_REPO = "DELETE_GIT_REPO";
export const CREATE_GIT_REPO = "CREATE_GIT_REPO";
export const STAR_GIT_REPO = "STAR_GIT_REPO";
export const PROTECT_GIT_REPO = "PROTECT_GIT_REPO";
export const FORCE_UPDATE_GIT_REPO = "FORCE_UPDATE_GIT_REPO";
